export const goaBoundary = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: {
        dt_code: "585",
        district: "North Goa",
        st_code: "30",
        year: "2011_c",
        st_nm: "Goa"
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [74.2511, 15.4914],
            [74.1997, 15.4664],
            [74.1789, 15.4371],
            [74.1241, 15.4378],
            [74.1098, 15.419],
            [74.1036, 15.4274],
            [74.0685, 15.4114],
            [74.0559, 15.4068],
            [74.0556, 15.4075],
            [74.0536, 15.4343],
            [74.0345, 15.4465],
            [74.041, 15.4514],
            [74.0256, 15.4737],
            [74.0307, 15.4789],
            [73.9616, 15.5398],
            [73.9442, 15.5242],
            [73.9616, 15.5029],
            [73.9616, 15.5026],
            [73.9548, 15.4869],
            [73.9504, 15.4775],
            [73.9568, 15.4643],
            [73.9572, 15.4636],
            [73.9456, 15.4483],
            [73.934, 15.433],
            [73.904, 15.4176],
            [73.8805, 15.435],
            [73.8632, 15.4291],
            [73.8492, 15.4525],
            [73.8029, 15.4504],
            [73.7879, 15.4639],
            [73.8025, 15.4615],
            [73.8148, 15.4918],
            [73.7917, 15.5005],
            [73.7661, 15.4946],
            [73.7552, 15.5464],
            [73.732, 15.5907],
            [73.7375, 15.6171],
            [73.7229, 15.6307],
            [73.6902, 15.7223],
            [73.6769, 15.7292],
            [73.6844, 15.7278],
            [73.6942, 15.7226],
            [73.7283, 15.7198],
            [73.7426, 15.7355],
            [73.7852, 15.7254],
            [73.7855, 15.7254],
            [73.7859, 15.7261],
            [73.8019, 15.7376],
            [73.8206, 15.7404],
            [73.8237, 15.7407],
            [73.8247, 15.7411],
            [73.8254, 15.7442],
            [73.8414, 15.7731],
            [73.8516, 15.7808],
            [73.8547, 15.7975],
            [73.856, 15.7999],
            [73.8574, 15.7996],
            [73.8795, 15.7741],
            [73.8751, 15.7508],
            [73.9388, 15.7428],
            [73.9517, 15.7163],
            [73.9436, 15.6986],
            [73.964, 15.6909],
            [73.9674, 15.6356],
            [73.9677, 15.6304],
            [73.9909, 15.6116],
            [74.0212, 15.606],
            [74.0311, 15.6227],
            [74.1006, 15.6425],
            [74.1132, 15.646],
            [74.1183, 15.6519],
            [74.1193, 15.6523],
            [74.1264, 15.6526],
            [74.1356, 15.6485],
            [74.1646, 15.6537],
            [74.1673, 15.6718],
            [74.1809, 15.6822],
            [74.1908, 15.6791],
            [74.1871, 15.6676],
            [74.2041, 15.6638],
            [74.2051, 15.6509],
            [74.2365, 15.6686],
            [74.2521, 15.6544],
            [74.2443, 15.6262],
            [74.2644, 15.6154],
            [74.2453, 15.5666],
            [74.2617, 15.5649],
            [74.278, 15.5461],
            [74.2783, 15.5228],
            [74.2511, 15.4918],
            [74.2511, 15.4914]
          ]
        ]
      }
    },
    {
      type: "Feature",
      properties: {
        dt_code: "586",
        district: "South Goa",
        st_code: "30",
        year: "2011_c",
        st_nm: "Goa"
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [73.934, 15.433],
            [73.9456, 15.4483],
            [73.9572, 15.4636],
            [73.9568, 15.4643],
            [73.9504, 15.4775],
            [73.9548, 15.4869],
            [73.9616, 15.5026],
            [73.9616, 15.5029],
            [73.9442, 15.5242],
            [73.9616, 15.5398],
            [74.0307, 15.4789],
            [74.0256, 15.4737],
            [74.041, 15.4514],
            [74.0345, 15.4465],
            [74.0536, 15.4343],
            [74.0556, 15.4075],
            [74.0559, 15.4068],
            [74.0685, 15.4114],
            [74.1036, 15.4274],
            [74.1098, 15.419],
            [74.1241, 15.4378],
            [74.1789, 15.4371],
            [74.1997, 15.4664],
            [74.2511, 15.4914],
            [74.2756, 15.4493],
            [74.2688, 15.419],
            [74.276, 15.3915],
            [74.3233, 15.3679],
            [74.3172, 15.3292],
            [74.3362, 15.2947],
            [74.3264, 15.2833],
            [74.2763, 15.2833],
            [74.2514, 15.2585],
            [74.2596, 15.2411],
            [74.3015, 15.2244],
            [74.3172, 15.1865],
            [74.2852, 15.1489],
            [74.2848, 15.1141],
            [74.2726, 15.0977],
            [74.2964, 15.0413],
            [74.2678, 15.0016],
            [74.2535, 14.9978],
            [74.2644, 14.9786],
            [74.2525, 14.9588],
            [74.2365, 14.9664],
            [74.2014, 14.9254],
            [74.1792, 14.9567],
            [74.1649, 14.9581],
            [74.1636, 14.9581],
            [74.1544, 14.9431],
            [74.1619, 14.9118],
            [74.1241, 14.925],
            [74.0856, 14.9006],
            [74.0808, 14.9104],
            [74.044, 14.9174],
            [74.0498, 14.9591],
            [74.0348, 14.9971],
            [74.0212, 15.0117],
            [73.9888, 15.0204],
            [73.982, 15.0549],
            [73.9718, 15.0524],
            [73.9664, 15.0667],
            [73.9122, 15.0859],
            [73.9269, 15.097],
            [73.918, 15.1081],
            [73.9354, 15.1123],
            [73.9361, 15.1339],
            [73.9497, 15.1447],
            [73.8843, 15.3546],
            [73.871, 15.3713],
            [73.8417, 15.3602],
            [73.8083, 15.3773],
            [73.806, 15.394],
            [73.7913, 15.3943],
            [73.7838, 15.4089],
            [73.7947, 15.4145],
            [73.8073, 15.3992],
            [73.8172, 15.4107],
            [73.8261, 15.403],
            [73.8404, 15.4107],
            [73.8465, 15.3981],
            [73.8741, 15.3964],
            [73.8921, 15.4086],
            [73.9398, 15.4086],
            [73.9262, 15.4225],
            [73.934, 15.433]
          ]
        ]
      }
    }
  ]
};